import BaseGenericEvent from '../../BaseGenericEvent';
import {RailsPdtConstants} from '../../PdtHelper/RailsPdtConstants';
import { getSearchEventData } from "../../PdtHelper/RailsPdtUtils";

export default class RailsPdtLandingEvent extends BaseGenericEvent {
  constructor(pdtData) {
    const data = pdtData;
    data.pageName = RailsPdtConstants.FunnelStep.LANDING;
    data.funnelStep = RailsPdtConstants.FunnelStep.LANDING;
    super(data);
    this.searchContextData = pdtData.searchContextData;
  }

  trackLandingEvent = () => {
    const basePdtObject = this.basePdtData();
    basePdtObject.rail_search_context = getSearchEventData(this.searchContextData);
    return basePdtObject;
  }
}
